// deps
import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const InputQty = styled(Text)(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
    marginRight: theme.spacing.xSmall,
}));

export const AddButtonContainer = styled.div`
    margin-left: ${(props) => props.theme.spacing.large};
    margin-right: ${(props) => `calc(${props.theme.spacing.xxSmall} * -1)`};
`;
